import { Helmet } from "react-helmet";
import { baseNewsSiteUrl, baseSiteUrl } from "../../../config";
import {
  ARTICLE_TYPES,
} from "../../constants/articles";

const ArticleSchema = ({
  slug,
  headline,
  description,
  articleDate,
  thumbnail,
  authors,
  articleType,
}) => {
  const articleISODate = `${articleDate.replace(" ", "T")}:00Z`;
  const schema = {
    "@context": "https://schema.org",
    "@type": ARTICLE_TYPES.includes(
      articleType
    )
      ? "NewsArticle"
      : "Article",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${baseNewsSiteUrl}/${slug}`,
    },
    headline: headline,
    description: description,
    image: (thumbnail && [thumbnail]) || undefined,
    author: authors.length
      ? authors.map(({ name }) => ({
          "@type": "Person",
          name,
        }))
      : [
          {
            "@type": "Organization",
            name: "Crunchyroll",
            url: `${baseSiteUrl}/`,
          },
        ],
    publisher: {
      "@type": "Organization",
      name: "Crunchyroll",
      logo: {
        "@type": "ImageObject",
        url: "https://www.crunchyroll.com/i/cr_logo.png",
      },
    },
    datePublished: articleISODate,
    dateModified: articleISODate,
  };

  return (
    <Helmet
      script={[
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(schema),
        },
      ]}
    />
  );
};

export default ArticleSchema;
